import { render } from "./profile-page.vue?vue&type=template&id=f80841dc"
import script from "./profile-page.vue?vue&type=script&lang=js"
export * from "./profile-page.vue?vue&type=script&lang=js"

import "./profile-page.vue?vue&type=style&index=0&id=f80841dc&lang=scss"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__